var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loader"},[_c('img',{attrs:{"src":"/images/loader.svg","alt":"Загрузка..."}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }